import React from "react";
import ProjectCard from "./ProjectCard";
import './works.css';
import projects from '../../assets/data.json';
const Works = () => {
    return (
        <section id='works'>
            <h2 className="worksTitle">Projects</h2>
            <p>Here are some projects I have worked on:</p>
            
            <div className="projectContainer">
                {projects.projects.map((project) => (
                    <ProjectCard
                        key={project.id}
                        id={project.id}
                        title={project.title}
                        githubLink={project.githubLink}
                        liveLink={project.liveLink}
                        description={project.description}
                        // image={project.image}
                    />
                ))}
            </div>
        </section>
    );
}

export default Works;